// Enlaces de afiliado reales del usuario (tag pps09d-21, mismo
// AMAZON_PARTNER_TAG que ya usa el resto del proyecto para las ofertas
// manuales de Amazon, ver manualAmazonDeals.js). Se muestran de forma
// intermitente entre las ofertas normales (ver la rotacion en
// ProductList.js) -- cada aparicion rota a la siguiente de esta lista, para
// que ninguna acapare el hueco y todas tengan exposicion con el tiempo.
//
// id: usado tambien en el backend (KNOWN_AMAZON_PROMO_IDS en server/index.js)
// para validar los clics registrados -- si se añade una promo nueva aqui,
// hay que añadir su id ahi tambien o el tracking de ese clic se descarta
// (el enlace en si sigue funcionando igual, solo se pierde la analitica).
export const AMAZON_PROMOS = [
    {
        id: 'prime',
        badge: 'Amazon Prime',
        title: 'Envios gratis e ilimitados con Prime',
        description: 'Envio en 1 dia, Prime Video, Prime Music y mas, todo en una sola suscripcion.',
        cta: 'Probar Prime',
        href: 'https://amzn.to/4ymiMFy'
    },
    {
        id: 'prime-joven',
        badge: 'Prime Joven',
        title: 'Prime con descuento para universitarios',
        description: 'Si tienes entre 18 y 24 años y estudias, Prime te sale mucho mas barato.',
        cta: 'Ver Prime Joven',
        href: 'https://amzn.to/4cr0mLe'
    },
    {
        id: 'music',
        badge: 'Amazon Music',
        title: 'Millones de canciones sin anuncios',
        description: 'Escucha musica y podcasts sin interrupciones, tambien offline.',
        cta: 'Probar Amazon Music',
        href: 'https://amzn.to/4zNXOAJ'
    },
    {
        id: 'kindle',
        badge: 'Kindle Unlimited',
        title: 'Lectura ilimitada de libros y comics',
        description: 'Miles de titulos incluidos, lee en el movil, tablet o Kindle sin coste extra.',
        cta: 'Probar Kindle Unlimited',
        href: 'https://amzn.to/3UvFagZ'
    },
    {
        id: 'prime-extra',
        badge: 'Prime',
        title: 'Suscripciones adicionales de Prime',
        description: 'Comparte las ventajas de Prime con otra persona de tu casa.',
        cta: 'Ver opciones',
        href: 'https://amzn.to/3SrAok5'
    },
    {
        id: 'prime-video',
        badge: 'Prime Video',
        title: 'Series y peliculas incluidas con Prime',
        description: 'Un catalogo enorme de contenido, incluido en tu suscripcion Prime.',
        cta: 'Ver Prime Video',
        href: 'https://www.primevideo.com?tag=pps09d-21&linkCode=abp&ref_='
    },
    {
        id: 'lista-nacimiento',
        badge: 'Lista de nacimiento',
        title: 'Crea tu lista de nacimiento en Amazon',
        description: 'Organiza todo lo que necesitas para la llegada del bebe en un solo sitio.',
        cta: 'Crear lista',
        href: 'https://amzn.to/4dfGfji'
    },
    {
        id: 'lista-bodas',
        badge: 'Lista de bodas',
        title: 'Crea tu lista de bodas en Amazon',
        description: 'Que tus invitados elijan el regalo perfecto, sin duplicados ni sorpresas.',
        cta: 'Crear lista',
        href: 'https://amzn.to/4rbJbDH'
    },
    {
        id: 'tienda',
        badge: 'Nuestra selección',
        title: 'La selección de Esganga en Amazon',
        description: 'Los productos que recomendamos de verdad, organizados por categorías.',
        cta: 'Ver selección',
        href: 'https://amzn.eu/d/0dSgdQqO'
    }
];
